import './styles/error-alert-bar.scss';
import React, {PropTypes} from 'react';
import AlertBarBase from './alert-bar-base';

export const ErrorAlertBar = props =>
    <div className='error-alert-bar'>
        <AlertBarBase
            alertTitle={props.alertTitle}
            dismissHandler={props.dismissHandler}
            iconClass='icon-alert-warning-white'
            isDismissable={props.isDismissable}
            timeoutLength={props.timeoutLength}
            willAutoDismiss={props.willAutoDismiss}
        >
            {props.children}
        </AlertBarBase>
    </div>;

ErrorAlertBar.displayName = 'ErrorAlertBar';

ErrorAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    children: PropTypes.any.isRequired,
    dismissHandler: PropTypes.func.isRequired,
    isDismissable: PropTypes.bool,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool
};

ErrorAlertBar.defaultProps = {
    isDismissable: true,
    willAutoDismiss: false
};

export default ErrorAlertBar;



// WEBPACK FOOTER //
// ./src/shared/components/alert-bar/error-alert-bar.js